import axios from "axios";

const baseURL = process.env.REACT_APP_API_BASE_URL;
var apis = {
  'sendChatMessage': `${baseURL}chat`
}

export const sendChatMessage = (data) => {
  return axios.put(apis.sendChatMessage, data);
}
